export * as default from './Default.svelte';
